import React from "react";
import SvgIcon from "material-ui/SvgIcon";

const WHITE = "#fff";
const BLUE = "#00267f";
const RED = "#f31830";
const LIGHTGREY = "#ccc";
const DARKGREY = "#aaa";

export default function(p) {
  const { greyscale, ...props } = p;
  return (
    <SvgIcon viewBox="0 0 640 480" {...props}>
      <g fillRule="evenodd" strokeWidth="1pt">
        <path fill={WHITE} d="M0 0h640v480H0z" />
        <path fill={greyscale ? DARKGREY : BLUE} d="M0 0h213.337v480H0z" />
        <path
          fill={greyscale ? LIGHTGREY : RED}
          d="M426.662 0H640v480H426.662z"
        />
      </g>
    </SvgIcon>
  );
}



// WEBPACK FOOTER //
// ./src/merchant/accomodation/FrIcon.js